export default __webpack_public_path__ + "static/media/Gilroy-SemiBold.9a372547.woff2";